import axios from 'axios';
import apisUrls from '../urls';

const getWebsiteServicesFeaturesApi = (paramsFilter) => {
  return axios.get(apisUrls?.getWebsiteServicesFeaturesUrl(paramsFilter));
};

export default getWebsiteServicesFeaturesApi;
